const moodQuestions = [
  {
    id: 0,
    question: 'How fun was this sprint?',
  },
  {
    id: 1,
    question: 'How satisfied are you with your performance this sprint?',
  },
  {
    id: 2,
    question: `How do you rate your team's ability, collaboration and joint efforts this sprint?`,
  },
  {
    id: 3,
    question: `How satisfied are you with the output of this sprint?`,
  },
];

export default moodQuestions;
